const handleResponse = response => {
  const { topic = null, payload = null } = response || {};

  if (topic === 'request/log') {
    logger.debug('[@fingermarkglobal/protocols][handleResponse]', JSON.stringify(payload.log));
    return {};
  }

  return response;
};

export { handleResponse };
